<template>
  <div class="yhc-service-level-rank-display-mode-modal">
    <b-form-radio-group
      v-model="selectedMode"
      class="yhc-service-level-rank-display-mode-modal__radios"
      stacked
    >
      <b-form-radio value="both">両方表示</b-form-radio>
      <b-form-radio value="e_only">Eランク以下のみ</b-form-radio>
      <b-form-radio value="fg_only">FGランクのみ</b-form-radio>
    </b-form-radio-group>
  </div>
</template>

<script lang="ts">
import type { CorporationRankDisplayMode } from '../utils/yhcServiceLevelRankDisplayMode'

export default {
  name: 'YhcServiceLevelRankDisplayModeModal',
  props: {
    modelValue: {
      type: String as () => CorporationRankDisplayMode,
      required: true,
    },
    onModeSelected: {
      type: Function as () => (mode: CorporationRankDisplayMode) => void,
      required: true,
    },
  },
  computed: {
    selectedMode: {
      get(): CorporationRankDisplayMode {
        return this.modelValue
      },
      set(value: CorporationRankDisplayMode) {
        if (value === this.modelValue) {
          $core.$modals.closeTopModal()
          return
        }
        this.onModeSelected(value)
        $core.$modals.closeTopModal()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.yhc-service-level-rank-display-mode-modal {
  padding: 0.25rem 0;

  &__radios {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
